export type DashboardRole = 'platform_admin' | 'super_admin' | 'front_desk';

export interface DashboardUser {
  name: string;
  email: string;
  role: DashboardRole;
}

export interface CommandEntry {
  id: string;
  label: string;
  group: string;
  href?: string;
}

export function roleLabel(role: DashboardRole): string {
  switch (role) {
    case 'platform_admin':
      return 'Platform admin';
    case 'super_admin':
      return 'Agency owner';
    case 'front_desk':
      return 'Front desk';
    default: {
      const unknown: never = role;
      return unknown;
    }
  }
}

export function initials(name: string, email: string): string {
  const source = name.trim() || email;
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
}
